(() => {
  if (window.FumoNavTrackingLoaded) return;
  window.FumoNavTrackingLoaded = true;
  // GA4 のデータ取得は上位100行しか返らず、商品ごとに散らばる閲覧は数えられない。判断に使う4つの導線だけをイベント名でまとめて送る。
  // nav_related / nav_rec: 関連商品の補完枠を続けるか（11/6 判定）。nav_recent: 最近見た商品の欄を残すか。nav_top_picks: おすすめ枠の試し。判断が済んだら外す。
  const GA4_ID = 'G-8CJ1QNYJVN';
  const EVENTS = {related: 'nav_related', recent: 'nav_recent', 'top-picks': 'nav_top_picks'};
  document.addEventListener('click', event => {
    const a = event.target.closest && event.target.closest('a[href]');
    if (!a || typeof window.gtag !== 'function') return;
    let url;
    try { url = new URL(a.href, location.href); } catch (_) { return; }
    if (url.host !== location.host) return;
    const ref = url.searchParams.get('ref');
    // Search & Discovery・Shopify の推薦から出した関連商品は ref ではなく pr_rec_id が付く。
    const name = ref ? EVENTS[ref] : url.searchParams.has('pr_rec_id') ? 'nav_rec' : null;
    if (!name) return;
    window.gtag('event', name, {send_to: GA4_ID, nav_pos: url.searchParams.get('pos') || '', nav_path: url.pathname.slice(0, 100)});
  }, {capture: true});
})();
